module.exports = __webpack_public_path__ + "static/media/logo_animalcrossing_ko.732e3cc2.svg";